import { render, staticRenderFns } from "./DonutChart13.vue?vue&type=template&id=1198a300&scoped=true"
import script from "./DonutChart13.vue?vue&type=script&lang=js"
export * from "./DonutChart13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198a300",
  null
  
)

export default component.exports